import { observer } from 'mobx-react-lite'
import { ActiveColorsIndicator } from 'common/Prose/components/ActiveColorsIndicator/ActiveColorsIndicator'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { computed } from 'mobx'
import Styles from './ActiveColorIcon.module.scss'
import { HighlightText } from 'blaze-ui/icons'

export const HighlightColorIcon = observer(() => {
  const editorState = useContext(AlmanacEditorStateContext)
  const activeColors =
    computed(() => editorState?.highlightColors && Array.from(editorState.highlightColors)).get() || []

  return (
    <div className={Styles.wrapper}>
      <HighlightText />
      <ActiveColorsIndicator colors={activeColors} className={Styles.indicator} />
    </div>
  )
})
